import './App.css';
import { Routes, Route } from 'react-router-dom';
import Layout from './layouts/layout/Layout';
import About from './components/about/About';
import Skills from './components/skills/Skills';
import Contact from './components/contact/Contact';
import Portfolio from './components/portfolio/Portfolio';
import ProjectLayout from './layouts/project/ProjectLayout';
import PageLayout from './layouts/PageLayout';
import AgbaState from './context/agba/AgbaState';
import ErrorPage from './components/404Page/ErrorPage';

function App() {
  return (
    <>
      <AgbaState>
        <Routes>
          <Route path='/' element={<PageLayout />} />
          <Route path='/about' element={<Layout />}>
            <Route index element={<About />} />
          </Route>
          <Route path='/skill' element={<Layout />}>
            <Route index element={<Skills />} />
          </Route>
          <Route path='/contact' element={<Layout />}>
            <Route index element={<Contact />} />
          </Route>
          <Route path='/portfolio' element={<ProjectLayout />}>
            <Route index element={<Portfolio />} />
          </Route>
          <Route path='/*' element={<ErrorPage />} />
        </Routes>
      </AgbaState>
    </>
  );
}

export default App;
